class InputValidated {
	/**
	 * @param {Element} element
	 */
	constructor(element) {
		/** @private */ this.element = element;

		/** VERIFY IF EXISTS A TARGET ATTRIBUTE */
		if (this.targetAttribute == undefined)
			throw new Error('nenhum atributo de alvo para InputValidated');

		/** GET VALIDATE TOKEN */
		this.validateToken = element.getAttribute(this.targetAttribute);

		if (this.validateToken == null)
			throw new Error('nenhuma chave adicionada para o elemento', element);

		/**
		 * INPUT VALIDATOR CONTROLLER
		 * @private
		 * */
		this.InputValidatorController = InputValidatorController;

		/** SETUP THIS INSTANCE */
		this.setup();
	}

	/** @private */
	setup() {
		const attibutes = this.element.attributes;
		const linkComponentAttibute = attibutes.getNamedItem(
			'data-bs-inputValidated-linkcomponent'
		)?.value;

		const inputElement = this.getChildrenInput(this.element);
		this.insertInputElementListeners(inputElement, linkComponentAttibute);
	}

	/** @private */
	insertInputElementListeners(
		/** @type {HTMLInputElement}*/ element,
		/** @type {HTMLInputElement}*/ linkTarget
	) {
		element.oninput = ({target}) => {
			const inputController = this.InputValidatorController[this.validateToken];
			this.maskedValue = inputController.maskValue(target.value, this.element);

			/** INSERT MASK ON INPUT */
			target.value = this.maskedValue;
		};

		element.onchange = ({target}) => {
			const inputController = this.InputValidatorController[this.validateToken];
			this.maskedValue = inputController.maskValue(target.value, this.element);
			const validate = inputController.validate(this.maskedValue, this.element);

			/** INSERT VISUAL ATTRIBUTES */
			this.handlerInputAttibutes(validate.isValid, validate.message ?? '');
		};

		if (linkTarget) {
			this.linkComponent(linkTarget, ({target}) => {
				// GET CONTROLLER
				const inputController =
					this.InputValidatorController[this.validateToken];

				const validate = inputController.validate(
					this.maskedValue,
					this.element
				);

				/** INSERT VISUAL ATTRIBUTES */
				this.handlerInputAttibutes(validate.isValid, validate.message ?? '');
			});
		}
	}

	/** @private */
	getChildrenInput(/** @type {HTMLElement}*/ element) {
		/** @type {HTMLInputElement}  */
		let nativeInput = [...element.children].find(
			(child) => child.tagName == 'INPUT'
		);

		if (!nativeInput) {
			nativeInput = document.createElement('input');
			element.appendChild(nativeInput);
		}

		return nativeInput;
	}

	/** @private */
	linkComponent(
		/** @type {string} */ target,
		/** @type {(event:Event) => void} */ callback
	) {
		const targetComponent = document.getElementById(target);

		targetComponent.addEventListener('change', (event) => {
			if (event.target.value && this.maskedValue) callback(event, targetComponent);
		});
	}
	/** @private */
	handlerInputAttibutes(
		/** @type {boolean} */ isValid,
		/** @type {string} */ message
	) {
		const messageAttribute = 'data-bs-inputValidated-message';
		const stateAttribute = 'data-bs-inputValidated-state';
		const stateTypes = isValid ? 'success' : 'error';

		this.element.setAttribute(messageAttribute, message);
		this.element.setAttribute(stateAttribute, stateTypes);
	}
}

// SET TARGET ATTRIBUTE
InputValidated.prototype.targetAttribute = 'data-bs-inputValidated-controller';

[
	...document.querySelectorAll(`[${InputValidated.prototype.targetAttribute}]`)
].forEach((element) => new InputValidated(element));
